var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFB000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.29 26.678a3.632 3.632 0 0 1-3.64 3.625 3.632 3.632 0 0 1-3.64-3.625M2 21.938h27.3M27.48 21.938h.91c-2.011 0-4.55-1.623-4.55-3.625v-8.157C23.84 5.652 20.173 2 15.65 2s-8.19 3.652-8.19 8.156v8.156a3.632 3.632 0 0 1-3.64 3.625"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eb3b0b9ecb7b0e3eb11383157809e56f.svg";
export { ForwardRef as ReactComponent };